import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getCustomerList: {
        url: `${customerApi}/api/customer_group/customer`,
        type: 'GET',
    },
    getCustomerGrouping: {
        url: `${customerApi}/api/customer_group`,
        type: 'GET',
    },
    deleteGrouping: {
        url: `${customerApi}/api/customer_group/{id}`,
        type: 'DELETE',
    },
    addGrouping: {
        url: `${customerApi}/api/customer_group`,
        type: 'POST',
    },
    editGrouping: {
        url: `${customerApi}/api/customer_group/{id}`,
        type: 'PUT',
    },
    moveGrouping: {
        url: `${customerApi}/api/customer_group/customer/move`,
        type: 'POST',
    },
    getMoveCount: {
        url: `${customerApi}/api/customer_group/customer/move/stat`,
        type: 'POST',
    },
}
